<template>
    <span ref="tooltipBlock" class="author-tooltip-block" @mouseover.stop="show"
          @click.stop="show" @mouseleave="hide" v-if="infoArray">
       <slot></slot>
        <div class="author-tooltip-wrapper" :class="[position,  {'custom': customPosition}]" v-show="showTooltip">
            <div class="author-tooltip-arrow"></div>
            <div class="author-tooltip" ref="tooltip">
                <div class="author-tooltip-sert" v-if="isSert"><IconSertificate/>Є сертифікат</div>
                <div class="author-tooltip-title" v-for="item in infoArray">
                    <picture class="author-tooltip-logo" v-if="item.images && item.images.photo.original">
                        <source :srcset="`${item.images.webp['size-60']} 1x, ${item.images.webp['size-120']} 2x`" type="image/webp">
                        <source :srcset="`${item.images.photo['size-60']} 1x, ${item.images.photo['size-120']} 2x`" type="image/jpeg">
                        <img :src="item.images.photo['size-60']" alt="logo" loading="lazy" width="50" height="50">
                    </picture>
                    <div v-else-if="noPhoto" class="author-no-logo">
                        <IconUser/>
                    </div>
                    <div v-else class="author-no-logo">
                        <IconUser/>
                    </div>
                    <div class="author-tooltip-content">
                        <div>{{ item.full_name || item.name }}</div>
                        <div class="author-tooltip-details">
                            <span class="flex-v-center" v-if="item.country">
                                <CountryFlag :code="item.country.code" class="author-tooltip-country"/>
                                {{ item.country.name }}
                            </span>
                            <span v-else class="flex-v-center">
                                <CountryFlag code="UA" class="author-tooltip-country"/>
                                Україна
                            </span>
                            <a v-if="item.link" :href="item.link" target="_blank" class="author-tooltip-link"><IconLink/></a>
                        </div>
                    </div>
                </div>
                <div class="author-tooltip-text" v-if="(info.description || remark) && info.length < 2">
                    {{remark || info.description}}
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import CountryFlag from './CountryFlag.vue';
import IconSertificate from "./icons/IconSertificate.vue";
import IconLink from "./icons/IconLink.vue";
import IconUser from "./icons/IconUser.vue";
export default {
    name: "AuthorTooltip",
    props: ['info', 'isSert', 'remark', 'position'],
    data(){
        return {
            showTooltip: false,
            noPhoto: false,
            tooltipWidth: 0,
            customPosition: false,
            screenWidth: 0,
            flagUkraine: `${window.location.origin}/countries/ua.svg`,
            isTouchDevice: false
        }
    },
    mounted() {
        this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    },
    created() {
        this.getScreenWidth();
        window.addEventListener("resize", this.getScreenWidth);
    },
    destroyed() {
        window.removeEventListener("resize", this.getScreenWidth);
    },
    computed: {
        infoArray() {
            if(this.info.length) {
                return this.info
            } else {
                const info = [];
                info.push(this.info);
                return info
            }
        }
    },
    methods: {
        getScreenWidth() {
            this.screenWidth = window.innerWidth
        },
        show() {
            if ((!this.isTouchDevice && event.type === 'mouseover') ||
                (this.isTouchDevice && event.type === 'click')) {
                this.showTooltip = true

                this.$nextTick(() => {
                    const tooltipInfo = this.$refs.tooltip.getBoundingClientRect();
                    const currentTooltipWidth = this.tooltipWidth || this.$refs.tooltip.offsetWidth;
                    const tooltipBlockLeft = this.$refs.tooltipBlock.getBoundingClientRect().left;
                    if(this.tooltipWidth){
                        this.$refs.tooltip.style.maxWidth = `${this.tooltipWidth}px`;
                    } else if(currentTooltipWidth + tooltipInfo.x > this.screenWidth){
                        this.customPosition = true;
                        this.$refs.tooltip.style.right = `-${this.screenWidth - tooltipBlockLeft - 70}px`;
                    }
                })
            }
        },
        hide() {
            this.showTooltip = false
        }
    },
    components: {
        CountryFlag, IconSertificate, IconLink, IconUser
    }
}
</script>

<style lang="scss">
@import "../../../sass/front/helpers";
.author-tooltip {
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 2px -2px 29px 8px rgba(160, 174, 193, 0.05), 0px 10px 20px 20px rgba(0, 0, 0, 0.04);
    width: 320px;
    padding: 20px 15px;
    font-size: 12px;
    text-align: left;

    @include responsive-below($xs){
        width: 260px;
    }

    .author-no-logo {
        width: 55px;
        min-width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &-block {
        position: relative;
    }

    &-content {
        width: 100%;
        word-break: break-word;
    }

    &-title {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 13px;

        & + & {
            margin-top: 20px;
            position: relative;
            padding-top: 10px;

            &:before {
                content: "";
                display: block;
                position: absolute;
                left: -20px;
                right: -20px;
                top: 0;
                border-top: solid 1px #F5F6F7;
            }
        }
    }

    &-logo {
        width: 55px;
        min-width: 55px;
        height: 55px;

        img {
            object-fit: contain;
            object-position: top;
            height: 100%;
            border-radius: 50%;
            width: 100%;
        }
    }

    &-sert {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 16px;
        font-size: 12px;
        font-weight: 300;
        color: #494B4E;

        svg {
            color: #3CC13B;
        }
    }

    &-link {
        color: #C0C7D0;

        &:hover {
            color: #4578EB;
        }
    }

    &-details {
        margin-top: 8px;
        font-size: 12px;
        color: $text-second;
        display: flex;
        align-items: center;
        justify-content: space-between;


        svg {
            display: block;
        }
    }

    &-country {
        margin-right: 6px;
    }

    &-text {
        margin-top: 20px;
        color: $text-second;
    }

    &-arrow {
        width: 20px;
        height: 20px;
        transform: rotate(45deg);
        background: #FFFFFF;
        border-radius: 2px;
        position: absolute;
        z-index: 1;
        top: 0;
        right: 20px;
    }

    &-wrapper {
        position: absolute;
        z-index: 100;
        right: 0;
        top: 100%;
        padding-top: 10px;

        &.left {
            left: -15px;
            right: auto;

            .author-tooltip {
                &-arrow {
                    left: 20px;
                    right: auto;
                }
            }
        }
        &.center {
            left: 50%;
            right: auto;
            transform: translateX(-50%);

            .author-tooltip {
                &-arrow {
                    left: 50%;
                    transform: translateX(-50%) rotate(45deg);
                    right: auto;
                }
            }
        }
        &.custom {
            position: relative;
            padding-top: 0;

            .author-tooltip {
                position: absolute;
                top: 10px;

                &-arrow {
                    left: 50%;
                    transform: translateX(-50%) rotate(45deg);
                    right: auto;
                }
            }
        }
    }
}

@include responsive-below($xs) {
    .table .author-tooltip {
        &-wrapper:not(.center) {
            right: 50%;
            transform: translateX(50%);

            &.right {
                right: 0;
                transform: none;

                .author-tooltip-arrow {
                    right: 25px;
                }
            }
        }

        &-arrow {
            right: calc(50% - 10px);
        }
    }
}

</style>
